import { useEffect, useRef } from "react";
import * as React from "react";
import Box from "@mui/material/Box";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { Control, useController } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { PatientFormValues } from "../patient-form.component";

type FirstNameFieldProps = {
  control: Control<PatientFormValues, object>;
};

export default function FirstNameField({ control }: FirstNameFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const {
    field,
    formState: { errors },
  } = useController({
    name: "first_name",
    control,
    rules: {
      required: "First Name is required",
      pattern: {
        value: /^[a-z ,.'-]+$/i,
        message: "First Name is not valid.",
      },
    },
  });
  return (
    <Box display="flex" justifyContent="space-between">
      <PersonOutlineOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} />
      <TextField
        inputRef={inputRef}
        fullWidth
        label="First Name"
        required
        {...(Boolean(errors?.first_name?.message)
          ? { error: true, helperText: errors?.first_name?.message }
          : {})}
        {...field}
      />
    </Box>
  );
}
